module.exports = __webpack_public_path__ + "img/bot_gbjqr.9384de66.png";